export default __webpack_public_path__ + "static/media/Boris Kolev.85122cd1.png";